module.exports = __webpack_public_path__ + "static/media/play.c73cf36a.svg";